import React from "react";

const Card = ({ title, value, color }) => (
  <div className="bg-gray-900 border border-gray-700 rounded-xl p-4">
    <div className="text-xs text-gray-400 uppercase tracking-wide">{title}</div>

    <div className={`text-3xl font-bold mt-2 ${color}`}>{value}</div>
  </div>
);

export default function ScorePlusDashboard({ records = [] }) {
  const totalRecords = records.length;

  const completed = records.filter((r) => r.status === "Done").length;

  const completion =
    totalRecords === 0 ? 0 : Math.round((completed / totalRecords) * 100);

  const averageScore =
    totalRecords === 0
      ? 0
      : (
          records.reduce((sum, r) => sum + (Number(r.score) || 0), 0) /
          totalRecords
        ).toFixed(1);

  const totalMinutes = records.reduce(
    (sum, r) => sum + (Number(r.duration) || 0),
    0,
  );

  const totalHours = (totalMinutes / 60).toFixed(1);

  const uniqueDays = new Set(records.map((r) => r.date)).size;

  const uniqueActivities = new Set(records.map((r) => r.act)).size;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      <Card title="Activities" value={totalRecords} color="text-cyan-400" />

      <Card
        title="Completion"
        value={`${completion}%`}
        color="text-green-400"
      />

      <Card title="Avg Score" value={averageScore} color="text-yellow-400" />

      <Card title="Hours" value={totalHours} color="text-purple-400" />

      <Card title="Days" value={uniqueDays} color="text-orange-400" />

      <Card
        title="Activity Types"
        value={uniqueActivities}
        color="text-pink-400"
      />
    </div>
  );
}
